import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Constants } from '../../../constants/constants';
import { PageService } from '../../../services/page.service';

@Component({
    selector: 'opm-paging',
    templateUrl: './opm-paging.component.html',
    styleUrls: ['./opm-paging.component.less'],
    standalone: false
})

export class OpmPagingComponent implements OnInit{
  constructor(    
    private page: PageService
  ) { }
    @Input() recordsPerPage: number;
  
  @Input() currentPage: number = this.page.currentPage;
    @Input() totalRecords: number;
    @Output() pageChanged: EventEmitter<number> = new EventEmitter();

    ngOnInit(): void {
        if (this.recordsPerPage == null) {
          this.recordsPerPage = Constants.PagingConst.RecordsPerPage;
        }
    }

    PreviousPage(): void {
        if (this.currentPage < 1) {
            return;
        }

      this.currentPage--;
      this.page.currentPage = this.currentPage;
        this.pageChanged.emit(this.currentPage);
    }

    NextPage(): void {
      var nextRecords = this.totalRecords - (this.currentPage * this.recordsPerPage);
      
        if (nextRecords <= 0) {
            return;
        }

      this.currentPage++;
      this.page.currentPage = this.currentPage;

      this.pageChanged.emit(this.currentPage);
    }

    GetNextRecordsCount(): number {
        return this.totalRecords - (this.currentPage + 1) * this.recordsPerPage;
    };
}
